// CGP-253: Convert a Datepicker-picked day into the ISO 8601 string sent to
// the backend as `data.completed.completedAt` (persisted by CGP-256).
//
// The Datepicker hands back local midnight for the picked day (e.g.
// `2026-07-31T00:00:00` in the user's zone). A naive `.toISOString()` would
// shift that to UTC and roll the calendar day BACK for any user east of UTC
// (UTC+5 → `2026-07-30T19:00:00Z`), so an "Actual Completion Date" picked as
// Jul 31 would persist as Jul 30.
//
// We read the LOCAL calendar components and rebuild the instant at NOON UTC of
// that same day. Building from local components makes the emitted day
// timezone-independent, and pinning to noon (rather than midnight) keeps the
// UTC calendar date stable and resists accidental local-zone display shifts in
// either direction. The value stays a valid ISO 8601 timestamp, matching the
// CGP-256 contract.
export const toCompletionTimestamp = (date: Date): string =>
  new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0)
  ).toISOString();
